var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElInput',_vm._g(_vm._b({ref:"target",attrs:{"max":_vm.max}},'ElInput',_vm.textAttrs,false),_vm.textListerners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }